import type { SortValue } from "./useSearchFilters";

interface SortOption {
    value: SortValue;
    label: string;
}

// The two price options pass through to /products as sortBy=Price +
// sortDirection (see buildSearchUrl).
// TODO(backend): Figma also shows "Popularity" and "On Sale". They are HIDDEN
// (audit BR-08) because GET /products has no sort for either; add them back
// here, to SORT_VALUES in useSearchFilters (SortValue derives from it), and
// to buildSearchUrl once it does.
const SORT_OPTIONS: SortOption[] = [
    { value: "price-desc", label: "Price - High to Low" },
    { value: "price-asc", label: "Price - Low to High" },
];

interface SortPanelProps {
    selected: SortValue | null;
    onChange: (value: SortValue) => void;
    /** Optional heading; sidebar shows it, sheets generally don't. */
    showHeading?: boolean;
}

export const SortPanel = ({
    selected,
    onChange,
    showHeading = true,
}: SortPanelProps) => (
    <div data-testid="sort-panel" className="px-4 py-3">
        {showHeading && (
            <div className="text-sm font-bold text-neutral mb-2">
                Sort By
            </div>
        )}
        <div role="radiogroup" aria-label="Sort by" className="flex flex-col gap-2">
            {SORT_OPTIONS.map(({ value, label }) => (
                <label
                    key={value}
                    className="flex items-center gap-2 cursor-pointer"
                >
                    <input
                        type="radio"
                        name="sort"
                        value={value}
                        checked={selected === value}
                        onChange={() => onChange(value)}
                        className="radio radio-sm radio-secondary"
                    />
                    <span className="text-neutral">{label}</span>
                </label>
            ))}
        </div>
    </div>
);
